import React, { FC, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { withProcedureWraper } from '../..'
import { Routes } from '../../../../AppRoutes'
import { Box } from '../../../../components/box'
import { Icon } from '../../../../components/icon'
import { Table } from '../../../../modules/table'
import { useSelector } from '../../../../store/store'
import { TrainingService } from '../../../../services/training/training.service'
import { requestStatus } from '../../../../constants/statusConstants'
import ApprovalStatus from '../../../../components/status/approvalStatus'
import { Button } from '../../../../modules/button'
import { Modal } from 'react-bootstrap'
import { InputWraper, useForm } from '../../../../modules/form';
import { UserSelect } from '../../../../components/input/select/UserSelect'
import { mailRegexs } from '../../../../constants/mailTemplateConstants'
import { MailService } from '../../../../services/mail/mail.service'
import { getEnv } from '../../../../AppConfigs'
import { CreateNotification } from '../../../../components/notifier'

const siteUrl = getEnv('REACT_APP_APPROVER_TRANING_PLAN_URL');

export const procedureAdvanceOfferPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const user = useSelector(state => state.user);
  const currentUserName = user?.current?.username;
  const employees = useSelector((state: any) => state.employee.employees);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const [showModal, setShowModal] = useState(false);
  const [approverOptions, setApproverOptions] = useState([]);
  const [approver, setApprover] = useState('');
  const [userDepartment, setUserDepartment] = useState(null as any);

  const getTrainingPlan = () => {
    return TrainingService.getTrainingPlanByStatus(requestStatus.approved).then(res => {
      return { data: res.reverse(), count: res.length }
    }, error => {
      return { data: [], count: 0 }
    });
  }

  const onModalClose = () => {
    setShowModal(false);
  }

  const getTrainingPlanSubmitted = () => {
    return TrainingService.getTrainingPlanByStatus(requestStatus.submitted).then(res => {
      return { data: res.reverse(), count: res.length }
    }, error => {
      return { data: [], count: 0 }
    });
  }

  const checkUserDepartment = () => {
    const userDepartment = employees.find((o: any) => o.eMail.toLowerCase() === currentUserName.toLowerCase());
    setUserDepartment(userDepartment);
  }

  const onApproverChange = (selectedOptions: any) => {
    setApprover(selectedOptions ? selectedOptions.value : '');
  }

  const getApproverOptions = () => {
    const approvers = employees.filter((f: any) => f.eDepartment === userDepartment.eDepartment).map((o: any) => ({ label: o.Title, value: o.eMail, default: o.eDefault || false }));
    setApproverOptions(approvers);
    if (approvers.length > 0) {
      const defaultApprover = approvers.find((a: any) => a.default);
      setApprover(defaultApprover?.value || approvers[0].value);
    }
  }


  const sendMail = async () => {
    // debugger
    const approverTmp = employees.find((f: any) => f.eMail.toLowerCase() === approver.toLowerCase());
    const name = approverTmp.Title;
    const tomail = approverTmp.eMail;
    const template = mailtemplates.find((m: any) => m.eMailType === 'TPA');
    const content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.siteUrl, siteUrl);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, 'html', tomail);
    await MailService.sendMail(message);
  }

  const { getInputProps, handleSubmit } = useForm({
    structure: [
      {
        name: 'approver',
        label: 'Người duyệt',
      },
    ],
    onSubmit: async () => {
      const approverTmp = employees.find((f: any) => f.eMail === approver);
      const trainingPlan = {
        eApprovedBy: approverTmp ? `${approverTmp.eMail}|${approverTmp.Title}` : null,
      };
      updateTrainingPlan(trainingPlan);
    }
  })

  const updateTrainingPlan = (trainingPlan: any) => {
    TrainingService.updateTrainingPlan(null, trainingPlan).then(res => {
      CreateNotification({ title: 'Thành công', body: `Chỉnh sửa thành công.`, icon: '/icons/success.png' });
      sendMail();
    }, error => {
      CreateNotification({ title: 'Thất bại', body: `Chỉnh sửa thất bại.`, icon: '/icons/error.png' });
      console.log(error);
    });
    setShowModal(false);
  }

  useEffect(() => {
    if (employees) {
      checkUserDepartment();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employees])

  useEffect(() => {
    if (userDepartment) {
      getApproverOptions();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDepartment])

  return (
    <div className="ProcedureTrainingPlanPage">
      <div className="pd15">
        <Box
          title="Danh sách"
          titleRight={<div className="btnPlus" onClick={() => history.push(Routes.procedureAdvanceOfferCreate.path.replace(':id', '0'))}>
            <Icon.Plus />Tạo  mới
          </div>}
        >
          <Table
            className="table"
            onRowClick={(item) => history.push(Routes.procedureTrainingPlanDetail.path.replace(':plancode', item.fields.PlanCode).replace(':id', item.id))}
            structure={[
              {
                name: 'Mã',
                render: (item) => item.fields.PlanCode
              },
              {
                name: 'Tiêu đề',
                render: (item) => item.fields.Title
              },
              {
                name: 'Trạng thái',
                render: (item) => <ApprovalStatus status={item.fields.eStatus} />
              }
            ]}
            onFetchData={getTrainingPlan}
          />
        </Box>

        <Box title="Danh sách đang đợi duyệt"
          titleRight={
            <div className="btnPlus" onClick={() => { }}>
              {'Xem lịch sử duyệt'}
            </div>
          }>
          <Table
            className="table"
            // onRowClick={(item) => history.push(Routes.procedureTrainingPlanDetail.path.replace(':plancode', item.fields.PlanCode).replace(':id', item.id))}
            structure={[
              {
                name: 'Mã ',
                render: (item) => item.fields.PlanCode
              },
              {
                name: 'Tiêu đề',
                render: (item) => item.fields.Title
              },
              {
                name: 'Trạng thái',
                render: (item) => <ApprovalStatus status={item.fields.eStatus} />
              },
              {
                name: 'Chi tiết',
                render: (item) => (
                  <div className="d-flex">
                    {/* <Button type="button" label="Gửi yêu cầu duyệt" buttonType="success" onClick={() => sendApprovalRequest(item)} /> */}
                    <Button type="button" label="Chi tiết" className="ml-1" buttonType="dark" onClick={() => history.push(Routes.procedureTrainingPlanDetail.path.replace(':plancode', item.fields.PlanCode).replace(':id', item.id))} />
                  </div>
                )
              }
            ]}
            onFetchData={getTrainingPlanSubmitted}
          />
        </Box>
      </div>
      <Modal
        show={showModal}
        onHide={onModalClose}
        centered
      >
        <Modal.Body className="py-4">
          <form onSubmit={handleSubmit}>
            <InputWraper inputProps={getInputProps('approver')} renderInput={(s) => <UserSelect {...s} placeholder="Chọn người duyệt" options={approverOptions} value={approver} onChange={onApproverChange} />} />
            <div className="d-flex justify-content-center">
              <Button type="submit" label="Gửi" />
              <Button type="button" label="Đóng" buttonType="grey-outline" className="ml10" onClick={onModalClose} />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  )
})